<!--
 * @Desc: 问题单承载页面
 * @Author: hedahai
 * @Date: 2020-10-09 16:36:44
-->

<template>
  <div class="question-list" ref="questionList">
    <div class="guide">
      <guide :questions="questions" ref="guide" @clickEvent="guideDidClick"></guide>
    </div>
    <div class="content">
      <inventory ref="inventory" :data="questions" @changeGuideChecked="changeGuideChecked" @reloadData="getData"></inventory>
    </div>
  </div>
</template>

<script>
import guide from "@/views/caseSpace/questionList/guide.vue"
import inventory from "@/views/caseSpace/questionList/inventory.vue"
import {mediatorQuestionListApi, userQuestionListApi} from '@/api/question_list.js'
import {setStore, getStore} from '@/utils/utils.js'

export default {
  components: {
    guide,
    inventory
  },
  data() {
    return {
      questions: []
    }
  },
  created() {
    this.getData()
  },
  mounted() {
    let context = this.$refs.questionList
    context.style.height = document.body.clientHeight - 200 + 'px'
  },
  methods: {
    getData() {
      let params = {mediationId: this.$route.query.meetingid}
      let loginInfo = JSON.parse(getStore('loginInfo'))
      if (loginInfo.personType === 'STAFF') {
        mediatorQuestionListApi(params).then(res => {
          let list = res.data.data
          this.questions = list
          console.log(this.questions)
        }).catch(err => {
          console.log(err)
        })
      } else {
        userQuestionListApi(params).then(res => {
          let list = res.data.data
          this.questions = list
          console.log(this.questions)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    guideDidClick(idString) {
      // console.log('导航点击', idString)
      this.$refs.inventory.scrollToTargetQuestion(idString)
    },
    changeGuideChecked(index) {
      this.$refs.guide.changeSelIndex(index)
    },
    saveAllQuestion(){
      return this.$refs['inventory'].saveAllQuestion()
    }
  },
}
</script>

<style lang="scss">
.question-list {
  height: 500px;
  margin-bottom: 20px;
  // width: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  // overflow: scroll;
  .guide {
    width: 180px;
    // background: red;
  }

  .content {
    // background: green;
    flex: 1;
  }
}
</style>
